import { render, staticRenderFns } from "./salaryType.vue?vue&type=template&id=bda5389c&scoped=true"
import script from "./salaryType.vue?vue&type=script&lang=js"
export * from "./salaryType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda5389c",
  null
  
)

export default component.exports